import { createApp } from 'vue';
import { createPinia } from 'pinia';

import './assets/scss/main.scss';
import App from './App.vue';
import router from '@/router';

import { hasResponseError } from '@/utils';

// Vuetify
import vuetify from './plugins/vuetify';
import mixin from './plugins/mixin';

// Scrollbar
import VueLazyload from 'vue-lazyload-ssr';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(vuetify);
app.use(VueLazyload, {
	lazyComponent: true,
	throttleWait: 50,
});
app.mixin(mixin);
app.mount('#app'); // Mount app

// Import component
import IconInline from '@/components/IconInline.vue';
app.component('IconInline', IconInline);
import Pic from '@/components/Pic.vue';
app.component('Pic', Pic);
import PopupMessage from '@/components/Popup/Message.vue';
app.component('PopupMessage', PopupMessage);
import Waiting from '@/components/Waiting.vue';
app.component('Waiting', Waiting);
// <Icon icon="tabler:mail" :width="20" :height="20" />
import { Icon } from '@iconify/vue';
app.component('Icon', Icon);
import GlobalLogo from '@/components/MainLogo.vue';
app.component('GlobalLogo', GlobalLogo);

app.provide('hasResError', hasResponseError);
